<div *ngFor="let list of wizardList">
    <div
        class="wizard-point"
        *ngIf="list.type === 'card' && list.id === activeWizardSlide"
        @fadeIn
    >
        <div class="row slide-container">
            <div class="col-12">
                <p class="font-weight-bold text-center slide-title">
                    {{ list.slideTitle | translate }}
                </p>
            </div>
            <app-carousel
                [slides]="list"
                (optionChosen)="chooseOption($event)"
                [handler]="getSelectionHandler()"
            ></app-carousel>
        </div>
    </div>
    <div
        class="wizard-point"
        *ngIf="list.type === 'collaboration' && list.id === activeWizardSlide"
        @fadeIn
    >
        <div class="collaboration-form">
            <div class="collaboration-settings">
                <app-container-collaboration-settings
                    [visibilityOptions]="availableVisibilityOptions"
                    [accessibilityOptions]="availableAccessibilityOptions"
                    [selectedVisibility]="selectedVisibility"
                    [selectedAccessibility]="selectedAccessibility"
                    (visibilityChange)="onVisibilityChange($event)"
                    (accessibilityChange)="onAccessibilityChange($event)"
                ></app-container-collaboration-settings>
            </div>
            <div
                class="d-flex justify-content-center continue-button-wrapper"
            >
                <button
                    type="button"
                    class="btn btn-tryb-blue btn-continue"
                    id="wizard-collaboration-continue-button"
                    (click)="onCollaborationContinue()"
                >
                    {{
                        `${entityTranslationKey}.wizardSlideTS.continue`
                            | translate
                    }}
                </button>
            </div>
        </div>
    </div>
    <div
        class="wizard-point"
        *ngIf="list.type === 'form' && list.id === activeWizardSlide"
        @fadeIn
    >
        <div class="create-project-form">
            <div class="text-container">
                <p class="text-center text-1">
                    {{
                        `${entityTranslationKey}.wizardSlide.text1` | translate
                    }}
                </p>
                <p class="text-center text-2">
                    {{
                        `${entityTranslationKey}.wizardSlide.text2` | translate
                    }}
                    <span class="text-tryb-pink">{{
                            `${entityTranslationKey}.wizardSlide.text3` | translate
                        }}</span>
                    {{
                        `${entityTranslationKey}.wizardSlide.text4` | translate
                    }}
                </p>
            </div>
            <div class="wizard-form-component-wrapper">
                <app-wizard-form
                    [hasSubmitFailed]="hasSubmitFailed"
                    (newData)="onSubmit($event)"
                    (backClicked)="onGoBack()"
                    [type]="type"
                ></app-wizard-form>
            </div>
        </div>
    </div>
</div>
